export const getOptimizationTitle = (streamingType: string): string =>
  `${streamingType.charAt(0).toUpperCase()}${streamingType.slice(1)} Optimizations`;
